<template>
  <main-layout>
    <v-container v-if="!editModal">
      <div style="font-size: 23px" class="primary--text mb-3">แบบร่าง</div>
      <div>
        <div @click="showCreate" class="add-product mb-3">
          <em style="transform: scaleX(-1)" class="fas fa-share mr-2" />
          แชร์โพสต์
        </div>
        <v-pagination
          v-if="dataDraft.length"
          class="mb-2"
          :total-visible="15"
          v-model="pageNumberDraft"
          @input="changePageDraft"
          :length="pagelengthDraft"
        ></v-pagination>

        <div v-if="loading" class="text-xs-center pt-5">
          <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
        </div>
        <div v-else>
          <div
            class="mb-3"
            v-for="(item, k) in dataDraft"
            :key="k"
            style="border: 1px solid #fe433b; border-radius: 8px"
          >
            <v-layout row wrap class="ma-0 pl-3">
              <v-flex xs9 class="mt-2">
                <div style="font-weight: bold; font-size: 17px; color: black">
                  {{ item.name }}
                </div>
                <div>
                  {{ item.messages }}
                </div>
                <div class="caption">
                  {{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
                </div>
                <div>โพสต์โดย {{ item.admin }}</div>
              </v-flex>
              <v-flex xs3 class="text-xs-right">
                <v-btn @click="showEdit(item)" small color="primary" outline icon
                  ><v-icon small>edit</v-icon></v-btn
                >
                <v-btn @click="onDelete(item)" small color="primary" outline icon
                  ><v-icon small>delete</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
            <div class="px-3">
              <v-divider></v-divider>
            </div>
          </div>
        </div>
      </div>
      <v-divider class="my-3"></v-divider>
      <div style="font-size: 23px" class="primary--text mb-3">โพสต์ไปแล้ว</div>
      <div>
        <v-pagination
          class="mb-2"
          v-if="dataPublish.length"
          :total-visible="15"
          v-model="pageNumberPublish"
          @input="changePagePublish"
          :length="pagelengthPublish"
        ></v-pagination>

        <div v-if="loading" class="text-xs-center pt-5">
          <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
        </div>
        <div v-else>
          <div
            class="mb-3"
            v-for="(item, k) in dataPublish"
            :key="k"
            style="border: 1px solid #fe433b; border-radius: 8px"
          >
            <v-layout row wrap class="ma-0 pl-3">
              <v-flex xs9 class="mt-2">
                <div style="font-weight: bold; font-size: 17px; color: black">
                  {{ item.name }}
                </div>
                <div>
                  {{ item.messages }}
                </div>
                <div class="caption">
                  {{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
                </div>
                <div>โพสต์โดย {{ item.admin }}</div>
              </v-flex>
              <v-flex xs3 class="text-xs-right">
                <v-btn @click="showRead(item)" small color="primary" outline icon>
                  <em class="fas fa-eye" />
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="px-3">
              <v-divider></v-divider>
            </div>
          </div>
        </div>
      </div>
    </v-container>
    <v-container v-if="editModal" width="600px" persistent>
      <v-card v-if="editModal">
        <PostEdit
          :loadinggroup="loadinggroup"
          :groupOptions="groupOptions"
          :channels="channels"
          @onSave="onSave"
          @close="editModal = false"
          :edittype="edittype"
          :editdata="editdata"
        ></PostEdit>
      </v-card>
    </v-container>
  </main-layout>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import PostEdit from './PostEdit.vue'
import axios from 'axios'
export default {
  components: {
    PostEdit
  },
  data() {
    return {
      loadinggroup: true,
      channels: [],
      groupOptions: [],
      loading: false,
      totalDraft: 0,
      offsetDraft: 0,
      limitDraft: 10,
      pagetmpDraft: 1,
      pageNumberDraft: 1,
      dataDraft: [],
      totalPublish: 0,
      offsetPublish: 0,
      limitPublish: 10,
      pagetmpPublish: 1,
      pageNumberPublish: 1,
      dataPublish: [],
      editModal: false,
      edittype: '',
      editdata: ''
    }
  },
  computed: {
    pagelengthDraft() {
      if (this.totalDraft) {
        return Math.ceil(this.totalDraft / 10)
      } else {
        return 1
      }
    },
    pagelengthPublish() {
      if (this.totalPublish) {
        return Math.ceil(this.totalPublish / 10)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getData(false)
    this.getData(true)
    this.getChannel()
    this.getGroups()
  },
  methods: {
    getGroups() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      api.getPowerbuyGroup(data, (err, response) => {
        this.groupOptions = response.data.map((el) => {
          return { ...el, id: parseInt(el.id) }
        })
        this.loadinggroup = false
      })
    },
    async getFbName(userid) {
      return new Promise(async (resolve) => {
        var vm = this
        var fbusersname = vm.$store.state.facebook_users_name
        if (!fbusersname.some((el) => el.id == userid))
          var result = await axios.get(
            `https://graph.facebook.com/${userid}?fields=name&access_token=${vm.selectedBot.page_access_token}`
          )
        if (result) {
          resolve(result.data.name)
        } else resolve(getFbName)
      })
    },
    onDelete(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: this.selectedBot.pageid,
              id: item.id
            }
            this.loading = true
            api.deletePowerbuyShearPost(data, (response) => {
              this.loading = false
              this.onSave()
            })
          }
        })
    },
    changePageDraft(val) {
      var vm = this
      if (this.pagetmpDraft == val) {
        //dont do shit
      } else {
        this.pagetmpDraft = val
        vm.offsetDraft = vm.pageNumberDraft * this.limitDraft - this.limitDraft
        if (vm.pageNumberDraft != 1) {
          vm.offsetDraft + 1
        }
        this.getData(false)
      }
    },
    changePagePublish(val) {
      var vm = this
      if (this.pagetmpPublish == val) {
        //dont do shit
      } else {
        this.pagetmpPublish = val
        vm.offsetPublish = vm.pageNumberPublish * this.limitPublish - this.limitPublish
        if (vm.pageNumberPublish != 1) {
          vm.offsetPublish + 1
        }
        this.getData(true)
      }
    },
    getData(isPublish) {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        limit: this['limit' + (isPublish ? 'Publish' : 'Draft')],
        offset: this['offset' + (isPublish ? 'Publish' : 'Draft')],
        publish: isPublish
      }

      api.powerbuyGetFacebooksharePostManagement(data, (err, response) => {
        this.loading = false
        if (isPublish) {
          this.dataPublish = response.data
          this.totalPublish = response.total
        } else {
          this.dataDraft = response.data
          this.totalDraft = response.total
        }

        this.total = response.total
      })
    },
    getChannel() {
      var data = {
        pageid: this.selectedBot.pageid // pageid ที่เข้ามาจาก cms
      }

      this.loading = true
      api.powerbuyGetChannel(data, (err, response) => {
        this.loading = false
        this.channels = response.data
      })
    },
    showCreate() {
      this.edittype = 'create'
      this.editModal = true
    },
    showEdit(item) {
      this.edittype = 'edit'
      this.editdata = item
      this.editModal = true
    },
    showRead(item) {
      this.edittype = 'read'
      this.editdata = item
      this.editModal = true
    },
    onSave() {
      this.$swal.fire({
        text: 'สำเร็จ',
        type: 'success'
      })
      this.editModal = false
      this.getData(false)
      this.getData(true)
    }
  }
}
</script>

<style lang="scss">
.add-product {
  height: 80px;
  border: dashed rgb(189, 189, 189) 3px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(189, 189, 189);
  cursor: pointer;
  border-radius: 10px;
  font-size: 23px;
  transition: all 0.1s ease-out;
}
.add-product:hover {
  color: #ee6e73;
  border: dashed #ee6e73 3px;
  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/FacebookShearPostManager/main.vue